import React, { useEffect, useState } from 'react';

import { Box } from '@wds/box';
import { InputGroup, InputGroupAddon } from '@wds/input-group';
import { Input } from '@wds/input';
import { InputMessage } from '@wds/input-message';
import { Typography } from '@wds/typography';

import PropTypes from 'prop-types';
import { STRINGS } from './constants';
import getComponentWithTheme from '../../../../themeProvider';

const NumberCustomField = (props) => {
	const {
		id, label, value, onChange, required, readOnly, errors, setErrors, helperText, settings,
	} = props;
	const [state, setState] = useState('');
	const [error, setError] = useState('');

	useEffect(() => {
		if (errors?.[id]) {
			setError(errors[id]);
		} else {
			setError('');
		}
	}, [errors]);

	useEffect(() => {
		if (value) {
			setState(value);
		}
	}, []);

	const validateField = (updatedValue) => {
		setState(updatedValue);
		const errorResult = settings.validator(updatedValue);
		if ((errorResult && updatedValue.length > 0) || (required && updatedValue.length === 0)) {
			setErrors({ ...errors, [id]: errorResult });
			setError(errorResult);
		} else {
			setErrors((prevErrors) => {
				const { [id]: _, ...rest } = prevErrors;
				return rest;
			});
			setError('');
			onChange(updatedValue);
		}
	};

	const handleChange = (e) => {
		validateField(e.target.value);
	};

	return (
		getComponentWithTheme(
			<Box>
				<InputGroup
					id={`${id}-input-group`}
					label={`${label} ${required ? '' : `(${STRINGS.optional})`}`}
					required={required}
					color={errors?.[id] ? 'error' : undefined}
					disabled={readOnly}
					stretched
				>
					<InputGroupAddon>
						<Box display='flex' pl={2}>
							<Typography variant='sectionTitleSm'>#</Typography>
						</Box>
					</InputGroupAddon>
					<Input
						value={state}
						type='number'
						id={id}
						onChange={handleChange}
						onKeyPress={(event) => {
							if (!/[0-9]/.test(event.key)) {
								event.preventDefault();
							}
						}}
					/>
				</InputGroup>
				{helperText && <InputMessage id={`${id}-helper-text`}>{helperText}</InputMessage>}
				{errors?.[id] && <InputMessage color='error' id={`${id}-error-text`}>{error}</InputMessage>}
			</Box>,
		)
	);
};

NumberCustomField.propTypes = {
	id: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.any,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool.isRequired,
	readOnly: PropTypes.bool.isRequired,
	errors: PropTypes.object.isRequired,
	setErrors: PropTypes.func.isRequired,
	helperText: PropTypes.string,
	settings: PropTypes.object,
};
export default NumberCustomField;
